import React from 'react';
import { Stack } from '@mui/material';
import CustomStepper from '../HomePage/Stepper/Steps';
import { useOkta } from '../../hooks/oktaHook';
import TitleStackComponent from '../../components/TitleStack/TitleStack';
import votingStepper from '../../assests/images/votingstepper.svg';

const VotingStepper = ({ tasks, loading, userLevel, userType }) => {
  const { userDetails } = useOkta();
  return (
    <div style={{ display: 'flex' }}>
      <Stack sx={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <TitleStackComponent
          title={`Hey ${userDetails.username}! Let’s start the voting`}
          titleVariant="h5"
          stackWidth={'100%'}
          style={{ left: '-150px !important' }}
        />
        <CustomStepper
          style={{ width: '100%' }}
          tasks={tasks}
          screen={'voting'}
          usertype={userType}
          userlevel={userLevel}></CustomStepper>
      </Stack>

      <img
        src={votingStepper}
        alt={'votingstepper'}
        width={170}
        height={128}
        style={{ marginLeft: '-150px' }}
      />
    </div>
  );
};

export default VotingStepper;
